import { StyleSheet } from 'react-native'

const useStyles = (theme, isTablet) => StyleSheet.create({
  mapContainer: {
    height: 300,
    width: '100%',
    marginBottom: 20
  },
  container: {
    paddingHorizontal: isTablet ? 40 : 20,
    transform: isTablet ? [
      { translateY: -80 }
    ] : []
  },
  buttonsContainer: {
    flexDirection: 'row',
    marginVertical: 20
  },
  bidButtonContainer: {
    flex: 1
  },
  bidButton: {
    backgroundColor: theme.GOLDEN_GRASS,
    width: '100%'
  },
  bookButtonContainer: {
    flex: 1,
    marginLeft: 5
  },
  bookButton: {
    backgroundColor: theme.JELLY_BEAN,
    width: '100%'
  },
  detailsContainer: {
    marginTop: 20
  },
  detailsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20
  },
  commodityContainer: {
    marginVertical: 20,
    flexDirection: 'row',
    alignItems: 'center'
  },
  commodity: {
    marginLeft: 15,
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: 14,
    backgroundColor: theme.CATSKILL_WHITE
  },
  commentsContainer: {
    marginVertical: 10
  },
  comments: {
    marginTop: 15
  }
})

export default useStyles
